import React from 'react';
import { ArrowPathIcon, CalendarIcon, MapPinIcon, InformationCircleIcon, BuildingOfficeIcon } from '@heroicons/react/24/outline';
import OpenLayersServiceLocations from './GoogleMapsServiceLocations';

const MapView = ({ shops, loading, selectedCity, selectedDate, onChangeFilters, isDesktopView = false }) => {
  return (
    <div className="space-y-4">
      {/* Map Container */}
      <div className="bg-white dark:bg-slate-800 shadow-sm rounded-b-xl overflow-hidden">
        {/* Map Header */}
        {/* <div className="bg-gradient-to-r from-purple-600 to-purple-700 px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-1.5 bg-white/20 rounded-lg">
                <MapPinIcon className="h-5 w-5 text-white" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white">Hartă service-uri</h3>
                <p className="text-purple-100 text-sm">
                  {loading ? 'Se încarcă...' : `${shops.length} ${shops.length === 1 ? 'service găsit' : 'service-uri găsite'}`}
                </p>
              </div>
            </div>
            
            {shops.length > 0 && (
              <div className="bg-white/20 px-3 py-1.5 rounded-full">
                <span className="text-white text-sm font-medium">{shops.length}</span>
              </div>
            )}
          </div>
        </div> */}

        {/* Map Content */}
        <div className="h-[400px] sm:h-[500px] relative p-4">
          {loading ? (
            <div className="absolute inset-0 flex items-center justify-center bg-slate-50 dark:bg-slate-700">
              <div className="flex flex-col items-center">
                <div className="p-4 bg-white dark:bg-slate-800 shadow-lg mb-4">
                  <ArrowPathIcon className="h-8 w-8 text-purple-600 dark:text-purple-400 animate-spin" />
                </div>
                <span className="text-slate-700 dark:text-slate-300 font-medium">Se încarcă harta...</span>
                <span className="text-slate-500 dark:text-slate-400 text-sm mt-1">Vă rugăm să așteptați</span>
              </div>
            </div>
          ) : shops.length === 0 ? (
            <div className="absolute inset-0 flex items-center justify-center bg-slate-50 dark:bg-slate-700">
              <div className="flex flex-col items-center text-center max-w-sm px-6">
                <div className="p-4 bg-white dark:bg-slate-800 shadow-lg mb-4">
                  <BuildingOfficeIcon className="h-12 w-12 text-slate-400 dark:text-slate-500" />
                </div>
                <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-2">
                  Nu există service-uri disponibile
                </h3>
                <p className="text-slate-600 dark:text-slate-400 mb-6 leading-relaxed">
                  Nu am putut găsi service-uri disponibile pentru criteriile selectate. Încercați să alegeți altă dată sau alt oraș.
                </p>
                <button
                  onClick={onChangeFilters}
                  className="px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-xl transition-colors duration-200 shadow-sm"
                >
                  Schimbă criteriile
                </button>
              </div>
            </div>
          ) : (
            <OpenLayersServiceLocations  
              fetchedData={shops} 
              selectedCity={selectedCity}
              selectedDate={selectedDate}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MapView;
